// client/src/types/lookup.ts

export interface Lookup {
  _id?: string;
  category: string;
  value: string;
  displayName: string;
  active: boolean;
  sessionRate?: number;
  numberOfSessions?: number;  // Added for organisations
  sortOrder?: number;  // Added for ordering items
  createdAt?: Date;
  updatedAt?: Date;
}

export interface APIErrorResponse {
  error: string;
  details?: Record<string, string[]>;
}

export const LOOKUP_CATEGORIES = {
  referralTypes: 'Referral Sources',
  sessionTypes: 'Session Types',
  sessionRates: 'Session Rates',
  organisations: 'Organisations',
  offboardingReasons: 'Offboarding Reasons',
  availability: 'Availability',
  gender: 'Gender',
  modality: 'Modality',
  experienceTraining: 'Experience / Training',
  underrepresentedCategories: 'Underrepresented Categories',
  language: 'Languages'
} as const;

export type LookupCategory = keyof typeof LOOKUP_CATEGORIES;